import {
  Alert,
  Box,
  Button,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  MenuItem,
  OutlinedInput,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useCompany } from "../../Companies/Provider";
import { useSite } from "../../Sites/Provider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers";
import Filter from "./Filter";
import { createYupSchema } from "../../../utilities/yupSchemaCreator";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import styled from "styled-components";
import { FilterList } from "@mui/icons-material";
import { useReports } from "../Provider";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../../services/auth";
import { useSubCompany } from "../../SubCompanies/Provider";

import "dayjs/locale/de";
import "dayjs/locale/en-gb";
import { MethodIds, PaymentType, PaidStatusEnum } from "../../../utilities/Enum";
import dayjs from "dayjs";

const yupSchema = Filter.reduce(createYupSchema, {});
const formSchema = Yup.object().shape(yupSchema);

function FilterForm({ setFilterClick }) {
  const { name } = useParams();
  const [locale] = useState("en-gb");

  const GridGroup1 = styled.div`
    width: fit-content;
    display: grid;
    padding: 20px;
    margin-bottom: 10px;
    grid-template-columns: ${(props) =>
      props.name === "Shift" ? "325px 325px" : "325px 325px 150px"};
    gap: 10px;
    grid-auto-rows: minmax(75px, auto);
    background: #f7f9fb;
    align-items: start;
  `;
  const Spinner = styled.div`
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-top: 4px solid #fff;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    animation: spin 1s linear infinite;

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `;

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  let theme = useTheme();
  let navigate = useNavigate();
  const { role, adminOn } = useAuth();
  const [MultiSitesChosen, setMultiSitesChosen] = useState([]);
  const [SiteStatus, setSiteStatus] = useState(null);
  const [isMember, setIsMember] = useState(null);
  const [PaidStatus, setPaidStatus] = useState(0);
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    if (value === 0 || value === "0") {
      setValue("sids", 0);
      setMultiSitesChosen(["0"]);
      return;
    }

    const selectedValues = typeof value === "string" ? value.split(",") : value;
    const isSelectingAll =
      selectedValues.includes(0) && !MultiSitesChosen.includes(0);

    const isDeselectingAll =
      !selectedValues.includes(0) && MultiSitesChosen.includes(0);

    if (isSelectingAll && SiteStatus === false) {
      setValue(
        "sids",
        sites
          .filter(Boolean)
          .map(({ id }) => id)
          .join("-"),
      );
      setMultiSitesChosen([0]);
    } else if (isSelectingAll && SiteStatus === true) {
      setValue(
        "sids",
        sites
          .filter(Boolean)
          .map(({ id }) => id)
          .join("-"),
      );
      setMultiSitesChosen([0]);
    } else if (isDeselectingAll) {
      setValue("sids", []);
      setMultiSitesChosen([]);
    } else if (selectedValues.includes(0)) {
      setValue("sids", 0);
      setMultiSitesChosen([0]);
    } else {
      setValue(
        "sids",
        Array.isArray(selectedValues)
          ? selectedValues.join("-")
          : selectedValues,
      );
      setMultiSitesChosen(selectedValues);
    }
  };

  const {
    state: { Names: sites, selected: SiteInfo },
    fetchSiteNames: fetchSites,
  } = useSite();
  const {
    state: { Names: companies },
    fetchNames: fetchCompanies,
  } = useCompany();
  const {
    state: {
      ExportExcelList,
      ExportShiftExcelList,
      ExportVoidExcelList,
      ExportSearchServicesExcelList,
      ExportSalesEndShiftExcel,
      ExportLiveTransactionExcel,
      PayServices,
      page,
      perPage,
      pageVoid,
      perPageVoid,
      companyIdAtt,
      siteIdAtt,
      PaidMethod,
      methodId,
      ExportTransactionsCheckedOutExcel,
      FilterData,
      from,
      to,
    },
    fetchListShift: getSiteShiftList,
    fetchTransaction: getSiteTransactionList,
    fetchShiftTransactionExcel,
    fetchVoidTransactionExcel,
    fetchLessPayroll,
    fetchHighestPayroll,
    fetchSitesBySales,
    fetchSitesByTickets,
    fetchVoidTransaction,
    fetchTransactionService,
    fetchEmployeesRoles,
    DailySalesPayroll,
    fetchPrevPayroll,
    fetchTransactionPaymentService,
    DailySalesByLocation,
    MonthlySalesByLocation,
    YearlySalesByLocation,
    fetchSitesZonesServices,
    fetchSearchByServices,
    SalesEndShift,
    fetchSalesEndShiftExcel,
    fetchTransactionLive,
    fetchLiveTransactionExcel,
    dispatch,
    fetchDailySalesByShift,
    fetchTransactionCheckedOut,
    fetchTransactionCheckedOutExcel,
  } = useReports();
  const {
    state: { selected: subCompany },
  } = useSubCompany();
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
    defaultValues: { isAllSites: true, sid: 0, ...FilterData },
  });
  const [companyId] = useState();
  const [Error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (role === "Admin") {
      if (companies?.length === 0) fetchCompanies();
    }
  }, [fetchCompanies, role, companies]);
  useEffect(() => {
    if (name === "Shift") {
      if (role === "Site")
        getSiteShiftList({ sid: adminOn?.id }, page, perPage);
      else if (role === "Admin" || role === "Company" || role === "SubCompany")
        if (getValues("cid") > 0 && getValues("sid") > 0)
          getSiteShiftList(getValues(), page, perPage);
    }
  }, [getSiteShiftList, page, perPage, adminOn?.id, getValues, name, role]);

  useEffect(() => {
    if (
      name === "Transactions" ||
      name === "TransactionsByService" ||
      name === "TransactionsServicePayment" ||
      name === "Voids" ||
      name === "Shift" ||
      name === "EmployeesRoles" ||
      name === "DailySales" ||
      name === "DailySalesByShift" ||
      name === "DailySalesLocation" ||
      name === "MonthlySalesLocation" ||
      name === "YearlySalesLocation" ||
      name === "SitesZonesServices" ||
      name === "SearchByServices" ||
      name === "SalesEndShift" ||
      name === "Live" ||
      name === "TransactionsCheckedOut"
    ) {
      if (role === "Admin") {
        if (companyIdAtt) {
          fetchSites(companyIdAtt, 0, { isActive: SiteStatus });
        }
      } else if (role === "Company") {
        fetchSites(adminOn?.id, 0, { isActive: SiteStatus });
      } else if (role === "SubCompany") {
        fetchSites(subCompany?.companyId, adminOn?.id, {
          isActive: SiteStatus,
        });
      }
    }
  }, [
    fetchSites,
    companyIdAtt,
    name,
    SiteStatus,
    adminOn?.id,
    role,
    subCompany,
  ]);

  useEffect(() => {
    setValue("isMembership", isMember);
  }, [isMember]);

  const getData = (props) => {
    switch (props) {
      case "cid":
        return companies;

      case "sid":
        return name === "Transactions" && role !== "SubCompany"
          ? [{ name: "All", id: true }, ...sites]
          : sites;

      case "paymentType":
        return PaymentType;
      case "paymentStatus":
        return PaidStatusEnum;
      case "methodId":
        return MethodIds;
      default:
    }
  };

  const onSubmit = async (values) => {
    setIsLoading(true);

    if (name === "Shift" && !values.sid) {
      setError({
        title: "You must select site before clicking the filter button!",
      });
      setIsLoading(false);
      return;
    }

    if (
      (name === "SiteBySales" ||
        name === "SitesByTickets" ||
        name === "LessPayroll" ||
        name === "HighestPayroll") &&
      !values.cid
    ) {
      setError({
        title: "You must select company before clicking the filter button!",
      });
      setIsLoading(false);
      return;
    }

    if (
      name === "Transactions" &&
      values.isAllSites === true &&
      (!values.fromDate || !values.toDate)
    ) {
      setError({
        title:
          "You must select From and To dates before clicking the filter button!",
      });
      setIsLoading(false);
      return;
    }

    if (
      name === "Transactions" &&
      values.isAllSites === true &&
      values.fromDate &&
      values.toDate
    ) {
      const diffMs = new Date(values.toDate) - new Date(values.fromDate);
      const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
      if (diffDays > 33) {
        setError({
          title: "The date range cannot exceed 33 days!",
        });
        setIsLoading(false);
        return;
      }
    }

    dispatch({ type: "set_FilterData", payload: values });

    try {
      switch (name) {
        case "Shift":
          await getSiteShiftList(values, page, perPage);
          ExportShiftExcelList.splice(0, ExportShiftExcelList.length);
          await fetchShiftTransactionExcel(values, 1, 100);
          break;

        case "Transactions":
          await getSiteTransactionList(values, page, perPage);
          break;

        case "Live":
          await fetchTransactionLive(values, page, perPage);

          ExportLiveTransactionExcel.splice(
            0,
            ExportLiveTransactionExcel.length,
          );
          await fetchLiveTransactionExcel(values, 1, 100);
          break;

        case "EmployeesRoles":
          await fetchEmployeesRoles(values);
          break;

        case "DailySales":
          await DailySalesPayroll(companyIdAtt, siteIdAtt, values);
          break;
        case "DailySalesByShift":
          await fetchDailySalesByShift(companyIdAtt, siteIdAtt, values);
          break;
        case "DailySalesLocation":
          await DailySalesByLocation(companyIdAtt, values.sids, values);

          break;
        case "MonthlySalesLocation":
          await MonthlySalesByLocation(companyIdAtt, values.sids, values);

          break;

        case "YearlySalesLocation":
          await YearlySalesByLocation(companyIdAtt, values.sids, values);

          break;

        case "SitesZonesServices":
          await fetchSitesZonesServices(companyIdAtt, values.sids);

          break;
        case "TransactionsByService":
          await fetchTransactionService(values, page, perPage);
          break;

        case "TransactionsServicePayment":
          PayServices.splice(0, PayServices.length);
          await fetchTransactionPaymentService(values);
          break;

        case "Voids":
          await fetchVoidTransaction(values, pageVoid, perPageVoid);
          ExportVoidExcelList.splice(0, ExportVoidExcelList.length);
          await fetchVoidTransactionExcel(values, 1, 100);
          break;

        case "LessPayroll":
          await fetchLessPayroll(companyIdAtt, values);
          break;

        case "HighestPayroll":
          await fetchHighestPayroll(companyIdAtt, values);
          break;

        case "PreviewPayroll":
          await fetchPrevPayroll(companyIdAtt, values);
          break;

        case "SiteBySales":
          await fetchSitesBySales(companyIdAtt, values);
          break;
        case "SalesEndShift": {
          await SalesEndShift(companyIdAtt, values.sids, page, perPage, values);
          ExportSalesEndShiftExcel.splice(0, ExportSalesEndShiftExcel?.length);
          await fetchSalesEndShiftExcel(
            companyIdAtt,
            values.sids,
            1,
            100,
            values,
          );
          break;
        }
        case "SitesByTickets":
          await fetchSitesByTickets(companyIdAtt, values);

          break;
        case "SearchByServices": {
          await fetchSearchByServices(
            companyIdAtt,
            values.sids,
            page,
            perPage,
            values,
          );
          ExportSearchServicesExcelList.splice(
            0,
            ExportSearchServicesExcelList.length,
          );
          break;
        }
        case "TransactionsCheckedOut":
          await fetchTransactionCheckedOut(values, page, perPage);
          ExportTransactionsCheckedOutExcel.splice(0, ExportExcelList.length);
          await fetchTransactionCheckedOutExcel(values, 1, 100);
          break;
        default:
      }

      setError(null);
    } catch (error) {
      setError(error.errors.message);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (getValues("cid") > 0 && getValues("sid") > 0 && name === "Shift") {
      getSiteShiftList(getValues(), page, perPage);
    } else if (getValues("cid") > 0 && name === "Transactions")
      getSiteTransactionList(getValues(), page, perPage);
    else if (getValues("cid") > 0 && getValues("sid") > 0 && name === "Voids")
      fetchVoidTransaction(getValues(), page, perPage);
    else if (
      getValues("cid") > 0 &&
      (getValues("sids") || getValues("sids") === 0) &&
      name === "SearchByServices"
    )
      fetchSearchByServices(
        getValues("cid"),
        getValues("sids"),
        page,
        perPage,
        getValues(),
      );
    else if (
      getValues("cid") > 0 &&
      (getValues("sids") || getValues("sids") === 0) &&
      name === "SalesEndShift"
    )
      SalesEndShift(
        getValues("cid"),
        getValues("sids"),
        page,
        perPage,
        getValues(),
      );
    else if (getValues("cid") > 0 && getValues("sid") > 0 && name === "Live")
      fetchTransactionLive(getValues(), page, perPage);
    else if (
      getValues("cid") > 0 &&
      getValues("sid") > 0 &&
      name === "TransactionsCheckedOut"
    )
      fetchTransactionCheckedOut(getValues(), page, perPage);
  }, [page, perPage, getValues]);

  useEffect(() => {
    if (role === "Company") {
      setValue("cid", adminOn?.id);
      dispatch({ type: "set_CompanyIdAtt", payload: adminOn?.id });
    } else if (role === "Site") {
      setValue("cid", SiteInfo?.company?.id);
      setValue("sid", adminOn?.id);
    } else if (role === "Auditor") {
      setValue("cid", SiteInfo?.company?.id);
      setValue("sid", adminOn?.id);
    } else if (role === "SubCompany") {
      setValue("cid", subCompany?.companyId);
    }
  }, [adminOn, role, subCompany, SiteInfo, setValue, dispatch]);

  useEffect(() => {
    dispatch({ type: "set_totalSize", payload: null });
    dispatch({ type: "set_DailySales", payload: [] });
    dispatch({ type: "set_listShift", payload: [] });
    dispatch({ type: "set_listVoidTransactions", payload: [] });
    dispatch({ type: "set_EmployeesRoles", payload: [] });
    dispatch({ type: "set_DailySales", payload: [] });
    dispatch({ type: "set_listTransactionService", payload: [] });
    dispatch({ type: "set_listlessPayroll", payload: [] });
    dispatch({ type: "set_listSitesSales", payload: [] });
    dispatch({ type: "set_listHighPayroll", payload: [] });
    dispatch({ type: "set_listSitesTickets", payload: [] });
    dispatch({ type: "set_listTransaction", payload: [] });
    dispatch({ type: "set_listTransactionPaySer", payload: [] });
    dispatch({ type: "set_DailySalesByLocation", payload: [] });
    dispatch({ type: "set_MonthlySalesByLocation", payload: [] });
    dispatch({ type: "set_YearlySalesByLocation", payload: [] });
    dispatch({ type: "set_SitesZonesList", payload: [] });
    dispatch({ type: "set_SearchByServiceList", payload: [] });
    dispatch({ type: "set_SalesEndShiftList", payload: [] });
    dispatch({ type: "set_listTransactionLive", payload: [] });
  }, []);

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      <Box>
        {Error && (
          <Alert severity="error" sx={{ width: "70%" }}>
            {Error.title || Error}
          </Alert>
        )}
        {isLoading && <Spinner />}
        {sites.length === 0 && companyId ? (
          <Alert severity="error">
            <Typography variant="Poster" component="span">
              {" "}
              You should add a new Site first,{" "}
              <Typography
                variant="Poster"
                component="span"
                onClick={() => navigate(`/sites/add/${companyId}`)}
                sx={{
                  "&:hover": {
                    textDecoration: "underline",
                    cursor: "pointer",
                  },
                }}>
                <strong>Add Site</strong>
              </Typography>
            </Typography>
          </Alert>
        ) : (
          ""
        )}
      </Box>
      <Box
        sx={{
          background: "#f7f9fb",
          padding: "20px",
          mt: 1,
          width: "95%",
          minHeight: "auto",
          height: "auto",
        }}>
        <GridGroup1>
          {(role === "Company" || role === "Site") && (
            <>
              <Box
                sx={{
                  background: "#f7f9fb",
                  width: "70%",
                }}>
                <span style={{ fontSize: "12px" }}>Company Name</span>
                <Box
                  sx={{
                    borderBottom: "1px solid gray",
                    width: "290px",
                    borderRadius: "8px",
                    textAlign: "center",
                    marginRight: "20px",
                    marginTop: "15px",
                  }}>
                  {role === "Company"
                    ? adminOn?.companyName
                    : SiteInfo?.company?.companyName}
                </Box>
              </Box>
            </>
          )}
          {role === "SubCompany" && (
            <>
              <Box
                sx={{
                  background: "#f7f9fb",
                  width: "70%",
                }}>
                <span style={{ fontSize: "12px" }}>Company Name</span>
                <Box
                  sx={{
                    borderBottom: "1px solid gray",
                    width: "290px",
                    borderRadius: "8px",
                    textAlign: "center",
                    marginRight: "20px",
                    marginTop: "15px",
                  }}>
                  {subCompany?.company?.companyName}
                </Box>
              </Box>
            </>
          )}
          {role === "Site" && (
            <>
              <Box
                sx={{
                  background: "#f7f9fb",
                  width: "100%",
                }}>
                <span style={{ fontSize: "12px" }}>Site Name</span>
                <div style={{ display: "flex" }}>
                  <Box
                    sx={{
                      borderBottom: "1px solid gray",
                      width: "290px",
                      borderRadius: "8px",
                      textAlign: "center",
                      marginRight: "20px",
                      marginTop: "15px",
                    }}>
                    {adminOn?.siteName}
                  </Box>
                </div>
              </Box>
            </>
          )}
          {role === "Auditor" && (
            <>
              <Box
                sx={{
                  background: "#f7f9fb",
                  width: "100%",
                }}>
                <span style={{ fontSize: "12px" }}>Site Name</span>
                <div style={{ display: "flex" }}>
                  <Box
                    sx={{
                      borderBottom: "1px solid gray",
                      width: "290px",
                      borderRadius: "8px",
                      textAlign: "center",
                      marginRight: "20px",
                      marginTop: "15px",
                    }}>
                    {adminOn?.siteName}
                  </Box>
                </div>
              </Box>
            </>
          )}
          {Filter.map((f, index) => (
            <React.Fragment key={index}>
              {f.select && (
                <FormControl
                  sx={{
                    width: theme.dimensions.width,
                    mt: theme.dimensions.mt,
display:
                        (role !== "Admin" && f.name === "cid") ||
                        (role === "Site" && f.name === "sid") ||
                        (role === "Auditor" && f.name === "sid") ||
                        (name === "LessPayroll" && f.name === "sid") ||
                        (name === "HighestPayroll" && f.name === "sid") ||
                        (name === "SiteBySales" && f.name === "sid") ||
                        (name === "SitesByTickets" && f.name === "sid") ||
                        (name !== "Transactions" && f.name === "paymentType") ||
                        (name !== "Transactions" && f.name === "paymentStatus") ||
                        (name === "DailySalesLocation" && f.name === "sid") ||
                        (name === "MonthlySalesLocation" && f.name === "sid") ||
                        (name === "YearlySalesLocation" && f.name === "sid") ||
                        (name === "SitesZonesServices" && f.name === "sid") ||
                        (name === "SearchByServices" && f.name === "sid") ||
                        (name === "SalesEndShift" && f.name === "sid")
                          ? "none"
                          : null,
                    ...(f.name === "sid" && {
                      border: "1px solid #e0e0e0",
                      borderRadius: "8px",
                      paddingInline: "16px",
                      marginBottom: "16px",
                      paddingTop: "5px",
                      paddingBottom: "16px",
                      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
                    }),
                  }}
                  error={
                    f.name === "cid" ||
                    f.name === "sid" ||
                    f.name === "paymentType"
                  }>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      flexWrap: "nowrap",
                    }}>
                    <span style={{ fontSize: "12px", whiteSpace: "nowrap" }}>
                      {f.label}
                      {f.name !== "paymentType" && <>*</>}
                    </span>
                    {f.name === "sid" && (
                      <FormControl>
                        <RadioGroup
                          row
                          aria-labelledby="site-status-radio-group-label"
                          name="site-status"
                          value={SiteStatus === null ? "all" : SiteStatus}
                          onChange={(e) => {
                            if (e.target.value === "all") {
                              setSiteStatus(null);
                            } else {
                              setSiteStatus(e.target.value === "true");
                            }
                          }}
                          style={{ width: "300px" }}>
                          {[
                            { label: "All", value: "all" },
                            { label: "Active", value: true },
                            { label: "Inactive", value: false },
                          ].map((status) => (
                            <FormControlLabel
                              key={status.label}
                              value={status.value}
                              control={<Radio size="small" color="success" />}
                              label={status.label}
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "12px",
                                  color: "grey",
                                },
                                "& .Mui-checked + .MuiFormControlLabel-label": {
                                  color: "black",
                                  fontWeight: "bold",
                                },
                              }}
                            />
                          ))}
                        </RadioGroup>
                      </FormControl>
                    )}
                  </div>
                  <Select
                    sx={{
                      mt: theme.dimensions.mt,
                    }}
                    error={!!errors[f.name]}
value={
                        (f.name === "cid" &&companyIdAtt) ||
                        (f.name === "sid" && siteIdAtt) ||
                        (f.name === "paymentType" && PaidMethod) ||
                        (f.name === "paymentStatus" && PaidStatus)
                      }
                    onChange={(e) => {
                      if (f.name === "sid") {
                        if (e.target.value === true) {
                          dispatch({
                            type: "set_SiteIdAtt",
                            payload: e.target.value,
                          });
                          setValue("isAllSites", true);
                          setValue("sid", 0);
                        } else {
                          dispatch({
                            type: "set_SiteIdAtt",
                            payload: e.target.value,
                          });
                          setValue("sid", e.target.value);
                          setValue("isAllSites", false);
                        }
                      } else if (f.name === "cid" && role !== "Company") {
                        dispatch({
                          type: "set_CompanyIdAtt",
                          payload: e.target.value,
                        });
                      } else if (f.name === "paymentType") {
                        dispatch({
                          type: "set_PaidMethod",
                          payload: e.target.value,
                        });
                      } else if (f.name === "paymentStatus") {
                        setPaidStatus(e.target.value);
                        dispatch({
                          type: "set_PaidStatus",
                          payload: e.target.value,
                        });
                      }
                    }}
                    inputProps={{
                      "aria-label": f.label,
                      ...(f.name !== "sid" ? register(f?.name) : {}),
                    }}
                    size="small">
                    {getData(f.name)?.map((s, index) => (
                      <MenuItem key={index} value={s.id}>
                        {f.name === "paymentType" ? s.name : s[f.data]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}

              {name === "Live" && f.name === "methodId" && (
                <FormControl
                  sx={{
                    width: theme.dimensions.width,
                    mt: theme.dimensions.mt,
                    mb: theme.dimensions.mb,
                  }}>
                  <span style={{ fontSize: "12px" }}>{f.label}</span>
                  <Select
                    sx={{
                      mt: theme.dimensions.mt,
                    }}
                    error={!!errors[f.name]}
                    inputProps={{
                      ...register(f?.name),
                    }}
                    size="small"
                    value={methodId}
                    onChange={(e) => {
                      dispatch({
                        type: "set_MethodId",
                        payload: e.target.value,
                      });
                    }}>
                    {getData(f.name)?.map((s, index) => (
                      <MenuItem key={index} value={s.id}>
                        {s.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
              {f.input && name === "Transactions" && (
                <Box>
                  <p style={{ fontSize: "12px" }}>{f.label}</p>
                  <TextField
                    InputProps={{
                      ...register(f?.name),
                    }}
                    error={!!errors[f.name]}
                    helperText={errors[f.name]?.message}
                    required
                    type={f.type}
                    size="small"
                    sx={{
                      width: theme.dimensions.width,
                    }}
                  />
                </Box>
              )}
              {f.checkBox && name === "Transactions" && (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isMember}
                      onChange={(e) => setIsMember(e.target.checked)}
                    />
                  }
                  label="Membership"
                />
              )}
              {f.name === "searchText" && name === "Live" && (
                <Box>
                  <p style={{ fontSize: "12px" }}>{f.label}</p>
                  <TextField
                    InputProps={{
                      ...register(f?.name),
                    }}
                    error={!!errors[f.name]}
                    helperText={errors[f.name]?.message}
                    required
                    type={f.type}
                    size="small"
                    sx={{
                      width: theme.dimensions.width,
                    }}
                  />
                </Box>
              )}
              {name === "TransactionsCheckedOut" &&
                f.name === "mainDuration" && (
                  <FormControl
                    sx={{ mt: theme.dimensions.mt, mb: theme.dimensions.mb }}>
                    <span style={{ fontSize: "12px" }}>{f.label}</span>
                    <TextField
                      InputProps={{
                        ...register(f?.name),
                      }}
                      error={!!errors[f.name]}
                      helperText={errors[f.name]?.message}
                      type="number"
                      size="small"
                      defaultValue={0}
                      sx={{
                        width: theme.dimensions.width,
                        mt: theme.dimensions.mt,
                      }}
                    />
                  </FormControl>
                )}
              {(name === "DailySalesLocation" ||
                name === "MonthlySalesLocation" ||
                name === "YearlySalesLocation" ||
                name === "SitesZonesServices" ||
                name === "SearchByServices" ||
                name === "SalesEndShift") &&
                f.name === "sid" && (
                  <FormControl
                    sx={{
                      m: 1,
                      width: 300,
                      border: "1px solid #e0e0e0",
                      borderRadius: "8px",
                      paddingInline: "16px",
                      marginBottom: "16px",
                      paddingTop: "5px",
                      paddingBottom: "16px",
                      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
                    }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        flexWrap: "nowrap",
                      }}>
                      <span style={{ fontSize: "12px", whiteSpace: "nowrap" }}>
                        Site Name
                      </span>
                      <FormControl>
                        <RadioGroup
                          row
                          aria-labelledby="site-status-radio-group-label"
                          name="site-status"
                          value={SiteStatus === null ? "all" : SiteStatus}
                          onChange={(e) => {
                            if (e.target.value === "all") {
                              setSiteStatus(null);
                            } else {
                              setSiteStatus(e.target.value === "true");
                            }
                          }}
                          style={{ width: "300px" }}>
                          {[
                            { label: "All", value: "all" },
                            { label: "Active", value: true },
                            { label: "Inactive", value: false },
                          ].map((status) => (
                            <FormControlLabel
                              key={status.label}
                              value={status.value}
                              control={<Radio size="small" color="success" />}
                              label={status.label}
                              sx={{
                                "& .MuiFormControlLabel-label": {
                                  fontSize: "12px",
                                  color: "grey",
                                },
                                "& .Mui-checked + .MuiFormControlLabel-label": {
                                  color: "black",
                                  fontWeight: "bold",
                                },
                              }}
                            />
                          ))}
                        </RadioGroup>
                      </FormControl>
                    </div>
                    <Select
                      multiple
                      value={MultiSitesChosen}
                      onChange={handleChange}
                      input={<OutlinedInput />}
                      MenuProps={MenuProps}
                      sx={{
                        mt: theme.dimensions.mt,
                        height: "auto",
                        "& .MuiSelect-select": {
                          py: 1,
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 0.5,
                        },
                      }}
                      size="small"
                      renderValue={(selected) => (
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "4px",
                          }}>
                          {selected.includes(0) ? (
                            <Chip key="all" label="All Sites" size="small" />
                          ) : (
                            selected.map((value) => (
                              <Chip
                                key={value}
                                label={
                                  sites.find((site) => site.id === value)
                                    ?.name || value
                                }
                                size="small"
                              />
                            ))
                          )}
                        </div>
                      )}>
                      {sites.length !== 0 && (
                        <MenuItem key="all" value={0}>
                          All Sites
                        </MenuItem>
                      )}
                      {sites.map((site) => (
                        <MenuItem
                          key={site.id}
                          value={site.id}
                          disabled={MultiSitesChosen.includes(0)}>
                          {site.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                )}
              {name === "SearchByServices" && f.name === "serviceTitle" && (
                <FormControl
                  sx={{ mt: theme.dimensions.mt, mb: theme.dimensions.mb }}>
                  <span style={{ fontSize: "12px" }}>{f.label}</span>
                  <TextField
                    InputProps={{
                      ...register(f?.name),
                    }}
                    error={!!errors[f.name]}
                    helperText={errors[f.name]?.message}
                    type="text"
                    size="small"
                    sx={{
                      width: theme.dimensions.width,
                      mt: theme.dimensions.mt,
                    }}
                  />
                </FormControl>
              )}
              {f.number && name === "Transactions" && f.name !== "mainDuration" && (
                <Box>
                  <p style={{ fontSize: "12px" }}>{f.label}</p>
                  <TextField
                    InputProps={{
                      inputProps: { min: 0 },
                      ...register(f?.name),
                    }}
                    defaultValue={0}
                    error={!!errors[f.name]}
                    helperText={errors[f.name]?.message}
                    required
                    type="number"
                    size="small"
                    sx={{ width: theme.dimensions.width }}
                  />
                </Box>
              )}

              {f.date && (
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  adapterLocale={locale}>
                  <FormControl
                    components={["DateRangePicker"]}
                    sx={{
                      width: theme.dimensions.width,
                      mt: theme.dimensions.mt,
                      mb: theme.dimensions.mb,
                      display:
                        name === "SitesZonesServices" || name === "Live"
                          ? "none"
                          : null,
                    }}>
                    <span style={{ fontSize: "12px" }}>
                      {f.label}
                      {name === "Shift" && <>*</>}
                    </span>
                    <DateTimePicker
                      minDate={
                        role === "SubCompany"
                          ? dayjs().startOf("year")
                          : f.name === "toDate" && from
                            ? dayjs(from)
                            : undefined
                      }
                      maxDate={
                        f.name === "toDate" &&
                        from &&
                        name === "Transactions" &&
                        getValues("isAllSites") === true
                          ? dayjs(from).add(33, "day")
                          : undefined
                      }
                      sx={{ mt: 1 }}
                      value={
                        f.name === "fromDate"
                          ? from
                            ? dayjs(from)
                            : null
                          : to
                            ? dayjs(to)
                            : null
                      }
                      onChange={
                        f.name === "fromDate"
                          ? (date) => {
                              setValue(f.name, date);
                              dispatch({ type: "set_from", payload: date });
                            }
                          : (date) => {
                              setValue(f.name, date);
                              dispatch({ type: "set_to", payload: date });
                            }
                      }
                      error={!!errors[f.name]}
                      helperText={errors[f.name]?.message}
                      slotProps={{
                        textField: {
                          error: errors[f.name]?.message,
                          helperText: (
                            <p style={{ color: "#d32f2f" }}>
                              {errors[f.name]?.message}
                            </p>
                          ),
                          size: "small",
                        },
                      }}
                    />
                  </FormControl>
                </LocalizationProvider>
              )}
            </React.Fragment>
          ))}
        </GridGroup1>
        <Box
          sx={{
            display: "flex",
            justifyContent: "end",
            alignContent: "start",
            mr: "30px",
            mt: "-30px",
          }}>
          <Button
            variant="contained"
            type="submit"
            sx={{
              backgroundColor: theme.color.blackBackground,
              color: "white",
              ml: 5,
              mt: 2,
              "&:hover": { background: `${theme.color.blackBackground}` },
              textTransform: "capitalize",
            }}
            disabled={isLoading}
            onClick={() => setFilterClick(true)}>
            {isLoading ? (
              <>
                <Spinner />
                <span style={{ margin: theme.spacing(0, 2) }}>Filter</span>
              </>
            ) : (
              <>
                <FilterList />
                <span style={{ margin: theme.spacing(0, 2) }}>Filter</span>
              </>
            )}
          </Button>
        </Box>
      </Box>
    </form>
  );
}

export default FilterForm;
